<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<app-filter
  [textBtnNew]="textBtnNew"
  [urlBtnNew]="urlBtnNew"
  [typeComponent]="typeComponent"
  (expFilter)="translateFilter($event)"
></app-filter>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalServiceOrders"
  (setPag)="setPag($event)"
></app-pagination>

<div *ngIf="alert" class="alert">
  <p class="msg">
    Por favor, verifique as pendências dos itens com a
    <span class="color">cor</span>
    !
  </p>
</div>

<app-list
  [dataList]="dataList"
  [currentUrl]="currentUrl"
  link="true"
  (callback)="openModal($event)"
></app-list>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalServiceOrders"
  (setPag)="setPag($event)"
></app-pagination>

<div class="shadow" *ngIf="modal" (click)="closeModal()"></div>
<div class="modal" *ngIf="modal">
  <span class="icn-close close" (click)="closeModal()"></span>

  <h1>Requisições SAP</h1>

  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <div id="list">
              <table width="100%" class="table">
                <thead>
                  <tr>
                    <th>
                      <div>Data Emissão</div>
                    </th>
                    <th>
                      <div>Numero Docto SAP</div>
                    </th>
                    <th>
                      <div>Descrição</div>
                    </th>
                    <th>
                      <div>Serviço/Equipamento</div>
                    </th>
                    <th>
                      <div>Tipo DOC SAP</div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <ng-container
                    *ngFor="let data of sapRequestData; let i = index"
                  >
                    <tr>
                      <td>
                        {{ data.dtEmissao | date: "dd/MM/yyyy" }}
                      </td>

                      <td>
                        {{ data.nrDoctoSap }}
                      </td>
                      <td>
                        {{ data.dsRetornoSap }}
                      </td>

                      <td>{{ data.cdProduto }} - {{ data.dsProduto }}</td>
                      <td>
                        {{ data.dsTpDocSap }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
